import { render } from "./Footer.vue?vue&type=template&id=3b877303&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=3b877303&lang=scss&scoped=true"

import exportComponent from "/Users/songlian/Developer/官網/配音工會/taipei-sound-recording/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b877303"]])

export default __exports__